<template>
  <div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-none d-sm-flex"
    >
      <div style="width: 100%" class="mt-5 m-0">
        <h3 class="text-center text-white m-0">Confirmation</h3>
        <br /><br />
      </div>
    </div>
    <div
      style="
        background-size: cover;
        color: #fff;
        position: fixed;
        width: 100%;
        top: 0px;
      "
      :style="{ backgroundImage: `url(${backgroundBanner})` }"
      class="d-flex d-sm-none"
    >
      <div style="width: 100%" class="mt-3">
        <CCol sm="12">
          <span @click="GoToPageNotification()">
            <br />
            <img
              src="../assets/img/iconInboxTeacher.png"
              width="40px"
              class="float-right mr-2 mt-2"
            />
          </span>

          <span class="mt-5 mb-5"> </span>
          <br /><br />
          <br /><br />
          <br /><br />
          <br /><br />
        </CCol>
      </div>
    </div>
    <CCard class="custom-card h-100">
      <CRow>
        <CCol sm="12" class="justify-content-center m-0">
          <CContainer>
            <CCol sm="12" lg="12" class="custom-margin">
              <CRow>
                <h5
                  class="text-left ml-2 mt-4 d-flex d-sm-none text-black bold"
                  style="font-size:24px"
                >
                  Find Tutor Status<br />
                </h5>

                <div
                  class="mx-auto d-flex justify-content-center col-12 ml-1 mt-1"
                >
                  <div class="p-0">
                    <CCol
                      sm="10"
                      lg="10"
                      class="mx-auto d-flex justify-content-center"
                    >
                      <CRow>
                        <CCol sm="12" lg="12" class="p-2">
                          <CRow>
                            <CCol sm="8" lg="8">
                              <!-- <strong>Job ({{ item.FindTutorId }})</strong> -->
                              <!-- <CRow class="d-none d-sm-flex">
                                <CCol sm="3" lg="3"
                                  ><strong> Class </strong></CCol
                                >
                                <CCol sm="9" lg="9">
                                  <CBadge color="primary">{{
                                    confirm.SubjectName
                                  }}</CBadge></CCol
                                >

                                <CCol sm="3" lg="3">
                                  <strong>Subject </strong></CCol
                                >
                                <CCol sm="9" lg="9">
                                  : {{ confirm.SubjectName }}
                                </CCol>

                                <CCol sm="3" lg="3"
                                  ><strong> Level </strong></CCol
                                >
                                <CCol sm="9" lg="9"> : {{ item.Level }} </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>Language </strong></CCol
                                >
                                <CCol sm="9" lg="9">
                                  :
                                  <span
                                    v-for="item in languages"
                                    v-bind:key="item.Id"
                                  >
                                    {{ item.Language }} ,
                                  </span>
                                </CCol>

                                <CCol sm="3" lg="3">
                                  <strong>Session </strong>
                                </CCol>
                                <CCol sm="9" lg="9">
                                  :
                                  <span
                                    v-for="item in sessions"
                                    v-bind:key="item.Id"
                                  >
                                    {{ item.Session }} ,
                                  </span>
                                </CCol>

                                <CCol sm="3" lg="3"
                                  ><strong> Time </strong>
                                </CCol>
                                <CCol sm="9" lg="9">
                                  :
                                  <span
                                    v-for="item in times"
                                    v-bind:key="item.Id"
                                  >
                                    {{ item.Time }} ,
                                  </span>
                                </CCol>
                              </CRow> -->

                              <CRow class="d-flex d-sm-none">
                                <CCol sm="2" lg="4">
                                  <span
                                    class="mt-2 float-left"
                                    style="font-size:17px"
                                    ><strong
                                      >Find Tutor (
                                      {{ confirm.FindTutorId }} )</strong
                                    ></span
                                  >
                                  <span
                                    class="mt-2 center float-right"
                                    style="font-size:17px"
                                  >
                                    <strong>
                                      {{ confirm.CreatedTime }}
                                    </strong></span
                                  >
                                </CCol>
                                <CCol
                                  sm="12"
                                  class="mt-2"
                                  style="font-size:17px"
                                >
                                  <strong>Status </strong> :
                                  <CBadge color="primary"> Pending </CBadge>
                                </CCol>
                                <CCol
                                  sm="12"
                                  class="mt-2"
                                  style="font-size:17px"
                                >
                                  <strong>Description </strong> : You have send
                                  an acceptance as tutor. Please wait for a
                                  response from student.
                                </CCol>
                                <!-- <CCol sm="12" class="mt-2">
                                  <strong>Class </strong> :
                                  <CBadge color="primary">{{
                                    confirm.SubjectName
                                  }}</CBadge>
                                </CCol> -->
                                <CCol sm="12" class="mt-4">
                                  <strong>Subject </strong> :
                                  {{ confirm.SubjectName }}
                                </CCol>
                                <CCol sm="12" class="mt-2"
                                  ><strong> Level </strong>: {{ confirm.Level }}
                                </CCol>

                                <CCol sm="12" class="mt-2">
                                  <strong>Language </strong>:
                                  <span
                                    v-for="item in languages"
                                    v-bind:key="item.Id"
                                  >
                                    {{ item.Language }}
                                  </span>
                                </CCol>

                                <CCol sm="12" class="mt-2">
                                  <strong>Session </strong>:
                                  <span
                                    v-for="item in sessions"
                                    v-bind:key="item.Id"
                                  >
                                    {{ item.Session }}
                                  </span>
                                </CCol>
                                <br />
                                <CCol sm="12" class="mt-2">
                                  <strong> Time </strong>:
                                  <span
                                    v-for="item in times"
                                    v-bind:key="item.Id"
                                  >
                                    {{ item.Time }}
                                  </span>
                                </CCol>
                                <CCol sm="12" class="mt-2">
                                  <label v-if="confirm.TypeOfGroup === false">
                                    <strong>Type: One-to-One</strong>
                                  </label>
                                  <label v-else> 
                                    <strong>Type: Group Of Two</strong>
                                  </label>
                                </CCol>
                              </CRow>
                            </CCol>
                            <br />
                          </CRow>
                        </CCol>
                      </CRow>
                    </CCol>
                  </div>
                </div>
              </CRow>
            </CCol>
          </CContainer>
        </CCol>
      </CRow>
    </CCard>

    <CModal title="Success" size="sm" color="success" :show.sync="successModal">
      <CCol sm="12" class="text-center">
        <div class="text-center">
          <img class="m-0" width="100px" src="../assets/img/iconsuccess.png" />
        </div>
      </CCol>

      <h3 class="text-center">SUCCESS !</h3>
      <CCol sm="12">
        <label class="text-center m-0">You have successfully accept job.</label>
      </CCol>
    </CModal>

    <CModal title="DECLINE" size="sm" color="success" :show.sync="declineModal">
      <CCol sm="12" class="text-center">
        <div class="text-center">
          <img class="m-0" width="100px" src="../assets/img/iconerror.png" />
        </div>
      </CCol>

      <h3 class="text-center">DECLINE !</h3>
      <CCol sm="12">
        <label class="text-center m-0"
          >You have successfully decline job.</label
        >
      </CCol>
    </CModal>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import vSelect from "vue-select";
import moment from "moment";
import backgroundUrl from "../assets/img/bgLogin.png";
import backgroundUrlTemplate from "../assets/img/bg.png";
import VuejsDialog from "vuejs-dialog";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
Vue.component("v-select", vSelect);

import "vue-select/dist/vue-select.css";
import "vue-select/src/scss/vue-select.scss";

// Tell Vue to install the plugin.
Vue.use(VuejsDialog);
import _ from "lodash";

import backgroundBanner from "../assets/img/bgApps.jpg";
export default {
  name: "Login",
  data() {
    return {
      backgroundBanner,
      confirm: {},
      confirmStatus: {},
      languages: [],
      sessions: [],
      times: [],
      acc: {},
      successModal: false,
      declineModal: false,
      Busy: false,
      status: false
    };
  },
  async mounted() {
    await this.GetConfirmationClass();
    await this.GetConfirmationLanguage();
    await this.GetConfirmationSession();
    await this.GetConfirmationTime();
    await this.GetAcceptJob();
    await this.GetTutorJob();
  },
  methods: {
    async GetConfirmationClass() {
      this.$API
        .get(this.$ConfirmationClass + "?notiId=" + this.$route.query.notiId, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.confirm = response.data;
            console.log("t" + this.confirm.StudentId);
          }
        });
    },
    async GetTutorJob() {
      this.$API
        .get(this.$CheckTutorJob + "?notiId=" + this.$route.query.notiId, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.status = response.data;
            console.log("t" + this.confirm.StudentId);
          }
        });
    },
    async GetConfirmationLanguage() {
      this.$API
        .get(
          this.$NotificationClassLanguage +
            "?notiId=" +
            this.$route.query.notiId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.languages = response.data;
          }
        });
    },

    async GetConfirmationSession() {
      this.$API
        .get(
          this.$NotificationClassSession +
            "?notiId=" +
            this.$route.query.notiId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.sessions = response.data;
          }
        });
    },

    async GetConfirmationTime() {
      this.$API
        .get(
          this.$NotificationClassTime + "?notiId=" + this.$route.query.notiId,
          {
            withCredentials: true
          }
        )
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.times = response.data;
          }
        });
    },

    async GetAcceptJob() {
      this.$API
        .get(this.$GetAcceptJob + "?notiId=" + this.$route.query.notiId, {
          withCredentials: true
        })
        .then(response => {
          if (response.status == 200 && response.data != null) {
            this.acc = response.data;
          }
        });
    },
    GoToPageNotification() {
      this.$router.push("/NotificationTeacher?userId=" + this.confirm.UserId);
    }
  }
};
</script>
